import React from "react";
import Input from "../../../../Components/Common/Input";
import Selector from "../../../../Components/Common/Selector";
import useSWR from "swr";
import { CategoryApiUrls } from "../../../../Api/Auth/ApiUrls";

const ChapterForm = ({ onChange, handleSubmit, errors, formData }) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);

  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="No"
          type="number"
          name="no"
          value={formData.no}
          onChange={onChange}
          placeholder="Enter chapter number"
          error={errors.no}
          min="0"
          required
        />
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter sub topic title"
          error={errors.title}
          required
        />
        <Input
          label="Description"
          type="text"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Enter description"
          error={errors.description}
        />
        <Selector
          name="category"
          label="Category"
          value={formData?.category}
          options={data?.data?.map((item) => ({
            label: item.title,
            value: item._id,
          }))}
          isClearable={false}
          onChange={onChange}
          error={errors?.category}
          isLoading={isLoading}
          required
        />
      </form>
    </>
  );
};

export default ChapterForm;
